module.exports = __webpack_public_path__ + "img/menu-icon-services.74eb55db.png";